import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot, setDoc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribeDoc = () => {};

    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      unsubscribeDoc();

      if (user) {
        await user.reload();
        if (user.emailVerified) {
          setCurrentUser(user);
          const docRef = doc(db, "users", user.uid);

          const docSnap = await getDoc(docRef);
          if (!docSnap.exists()) {
            try {
              await setDoc(docRef, {
                name: user.displayName || "Anonymous",
                email: user.email,
                picUrl: "",
                experience: 0,
                coins: 0,
                practiceHistory: [],
                decoration: "",
                joinedAt: new Date().toISOString()
              });
              console.log("Created new user profile after verification!");
            } catch (e) {
              console.error("Error creating profile:", e);
            }
          }

          unsubscribeDoc = onSnapshot(
            docRef,
            (snapshot) => {
              if (snapshot.exists()) {
                setUserProfile(snapshot.data());
              } else {
                setUserProfile(null);
              }
            },
            (error) => {
              console.error("Error fetching user profile:", error);
            }
          );
        } else {
          setCurrentUser(user);
          setUserProfile(null);
        }
      } else {
        setCurrentUser(null);
        setUserProfile(null);
      }
      setLoading(false);
    });

    return () => {
      unsubscribeAuth();
      unsubscribeDoc();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, userProfile }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}